export default __webpack_public_path__ + "static/media/new-msat-modal-4.4162b3ca.svg";